import { render, staticRenderFns } from "./NewsManagement.vue?vue&type=template&id=711cc6a1&scoped=true"
import script from "./NewsManagement.vue?vue&type=script&lang=js"
export * from "./NewsManagement.vue?vue&type=script&lang=js"
import style0 from "./NewsManagement.vue?vue&type=style&index=0&id=711cc6a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711cc6a1",
  null
  
)

export default component.exports